import React from "react";
// mui 5
import Typography from "@mui/material/Typography";
// fast marquee
import Marquee from "react-fast-marquee";
// custom components
import PokemonCardRecommendation from "../PokemonCardRecommendation";
import ErrorMessage from "../CommonComponents/ErrorMessage";
// custom hooks
import useGetAllPokemonRecommendation from "./hooks/useGetAllPokemonRecommendation";
// custom style
import {
  StyledContentWrapper,
  StyledRecommendation,
} from "./styledComponents";

function PokemonRecommendation() {
  // custom hook
  const {
    data,
    isLoading,
    isError,
    isSuccess,
  } = useGetAllPokemonRecommendation();

  // wait for all pokemons to load
  if (isLoading) {
    return <ErrorMessage msg="Loading pokemons..." />;
  }
  // show error
  if (isError) {
    return <ErrorMessage msg="Sorry could not load pokemons" />;
  }

  // empty collection message
  if (isSuccess && data.length === 0) {
    return <ErrorMessage msg="No pokemons in collection" />;
  }
  return (
    <StyledRecommendation>
      <Typography variant="h4" mb={2}>
        You may also like
      </Typography>

      <Marquee pauseOnHover={true} speed={50} gradient={false}>
        {data.map((pokemon) => (
          <StyledContentWrapper key={pokemon.id}>
            <PokemonCardRecommendation pokemon={pokemon} />
          </StyledContentWrapper>
        ))}
      </Marquee>
    </StyledRecommendation>
  );
}

export default PokemonRecommendation;
